import { Injectable } from "@angular/core";
//import { ErrorDialogService } from '../error-dialog/errordialog.service';
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from "@angular/common/http";

import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const baseUrl2 =
      `https:${window.location.origin.substring(window.location.protocol.length)}`;

    // const token: string = localStorage.getItem("accessToken");
    if (
      (baseUrl2 == "https://iaf-app.gke2.ope.gcp.renault.com" || baseUrl2 == "https://iaf-app.ope.apps.renault.com") &&
      !request.url.match(/grouperenault.sharepoint.com/g) &&
      !request.url.match(/idp2.renault.com/g) &&
      !request.url.match(/idp.renault.com/g) &&
      !request.url.match(/access_token/g) &&
      !request.url.match(/oidc/g) &&
      !request.url.match(/auth/g) &&
      !request.url.match(/k2-isa/g) &&
      !request.url.match(/k2-socle/g) 
      && !request.url.match(/getHappiCred/g)
       ) {
      // request = request.clone({
      //   headers: request.headers.set("Authorization", "Bearer " + token),
      // });
    }
    request = request.clone({
      headers: request.headers.set("Accept", "application/json"),
    });

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        let data = {};
        data = {
          reason:
            error && error.error && error.error.reason
              ? error.error.reason
              : "",
          status: error.status,
        };
        return throwError(error);
      })
    );
  }
}
